import * as React from "react";
import { useKnockoutObservable } from "../sharedComponents/hooks/useKnockoutObservable";
import { EditMessageViewModel, PostMessageViewModel } from "./types";

type ViewModelType = PostMessageViewModel | EditMessageViewModel;
export const MessageContext = React.createContext<ViewModelType>(null);

export const useMessageContext = <T extends ViewModelType = ViewModelType>() => React.useContext(MessageContext) as T;

const internalUseMessageContextValue = <TVM extends ViewModelType, T>(selector: F1<TVM, T>) => {
    const vm = useMessageContext<TVM>();
    return useKnockoutObservable(() => selector(vm));
};

export const useMessageContextValue = <T>(selector: F1<PostMessageViewModel, T>) => {
    return internalUseMessageContextValue<PostMessageViewModel, T>(selector);
};

export const useEditMessageContextValue = <T>(selector: F1<EditMessageViewModel, T>) => {
    return internalUseMessageContextValue<EditMessageViewModel, T>(selector);
};

export const useProjectOrTask = () => {
    return useMessageBoardOwnerInfo().getInfo();
};

export const useMessageBoardOwnerInfo = () => {
    const vm = useMessageContext();
    return vm.ownerInfo;
};

export const useIsArchived = () => {
    const [isArchived] = useMessageContextValue(vm => vm.isArchived?.());
    return isArchived;
};
